import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from "react-redux";
import {PersistGate} from 'redux-persist/lib/integration/react'
import {persistor, store} from "./redux/reducers/store";

const root = createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App/>
        </PersistGate>
    </Provider>
);
